<template>
  <div class="form-field">
    <slot></slot>

    <!-- Error message (renders only when provided and visible) -->
    <p v-if="errorMessage && showError" class="form-error" :id="`${id}-error`" role="alert">
      {{ errorMessage }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  id: string
  errorMessage?: string | null
  showError?: boolean
}>()

const showError = computed(() => !!props.errorMessage && !!props.showError)
</script>

<style scoped>
.form-error {
  color: #e32c57;
  font-size: 12px;
  line-height: normal;
  margin: 0px;
}

.form-field {
  padding-bottom: 16px;
}
</style>
